<template>
  <div
    class="stepper-view"
    :style="!is_mobile ? { position: 'relative', 'max-height': '76vh' } : {}"
  >
    <div class="step-head pa-6 pa-md-8">
      <span class="step-nr">
        {{ stepLabel }}
      </span>

      <k-spacing y="8"></k-spacing>

      <p class="step-subtitle" v-if="!changing">
        {{ formatText() }}
      </p>
      <p class="step-subtitle" v-else>
        {{ $i18n.locale == "nl" ? "Wijzig aanmelding" : "Change registration" }}
      </p>
      <h3 class="step-title" :class="is_mobile ? 'mt-1' : 'mt-1'">
        {{
          $i18n.locale == "nl"
            ? activity.content.nl.banner.title
            : activity.content.eng.banner.title
        }}
        <v-chip class="" color="var(--company-primary)" variant="tonal">
          {{
            activity.type === "eenopeen"
              ? $i18n.locale === "nl"
                ? "1 OP 1"
                : "1 ON 1"
              : $i18n.locale === "nl"
              ? "GROEPSACTIVITEIT"
              : "GROUP ACTIVITY"
          }}
        </v-chip>
      </h3>
      <span class="enroll-date" v-if="changing">
        {{
          toAmsterdamCalendarDate(enroll.date)
            .toLocaleDateString("nl-NL", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })
            .replace(/(\w{3})/, "$1.")
        }}
        {{ enroll.start }} -
        {{ enroll.end }}
      </span>
    </div>
    <div class="step-body pl-6 pl-md-8">
      <label
        v-if="!is_mobile"
        class="input-label mb-2 d-block"
        for="choose-date"
      >
        {{ $t("components.registerActivityDialog.dialog_date_choose") }}
      </label>
      <div v-if="!is_mobile">
        <div
          v-for="(item, index) in groupDatesFiltered"
          :key="index"
          class="slot-card-shell"
        >
          <!-- Het lint staat buiten de kaart en hapt haar rechterbovenhoek af.
               Een tijdslot met wachtlijst noemt geen vrije plekken: die zijn er
               niet, en de chip rechtsonder zegt het al. -->
          <span v-if="ready && !item.waitlist" class="slot-spots-ribbon">
            {{ spotLabel(item.specialist.slot) }}
          </span>
          <div
            :class="[
              getClassForDate(item),
              { 'has-ribbon': ready && !item.waitlist },
            ]"
            @click="
            !item.disabled &&
            !item.full &&
            !checkDateIfNeeded(
              item.date,
              item.specialist.slot.start,
              item.specialist.slot.end,
            )
              ? selectItem(item)
              : ''
          "
        >
          <div v-if="ready" class="h-100">
            <div class="d-flex h-100">
              <div class="date-col d-flex px-4">
                <div class="align-self-center d-flex flex-column">
                  <span class="group-register-list-month d-block">
                    {{ formatMonth(item.date) }}
                  </span>
                  <span class="group-register-list-date d-block">
                    {{ formatDay(item.date) }}
                  </span>
                  <span class="group-register-list-day d-block">
                    {{ formatWeekday(item.date) }}
                  </span>
                </div>
              </div>
              <div class="d-flex align-center group-col ga-14 pa-4 w-100">
                <div class="d-flex flex-column ga-4 slot-card-text">
                  <div class="d-flex">
                    <span class="group-register-list-starttime d-block">
                      {{ item.specialist.slot.start }} -
                      {{ item.specialist.slot.end }}
                    </span>
                  </div>

                  <div class="d-flex flex-column ga-2">
                    <span
                      class="group-register-list-address text-truncate"
                      v-if="item.specialist.slot.location_type == 'location'"
                    >
                      {{
                        activity.locations[locationIndex].data.street +
                        ", " +
                        activity.locations[locationIndex].data.postal_code +
                        " " +
                        activity.locations[locationIndex].data.city
                      }}
                    </span>
                    <span
                      class="group-register-list-address text-truncate"
                      v-else
                    >
                      Online | <span :style="{ opacity: item.specialist.placeholder ? 0.6 : 1 }">{{ item.specialist.name }}</span>
                    </span>
                    <div
                      v-if="item.specialist.slot.location_type == 'location'"
                      class="d-flex group-register-list-address text-truncate"
                    >
                      <span
                        :style="{
                          opacity: item?.specialist?.slot?.address?.room
                            ? 1
                            : 0.6,
                        }"
                      >
                        {{
                          item.specialist.slot.address.room
                            ? item.specialist.slot.address.room + " | "
                            : $i18n.locale == "nl"
                            ? "Nog niet bekend |"
                            : "Unknown | "
                        }}
                      </span>

                      <span :style="{ opacity: item.specialist.placeholder ? 0.6 : 1 }">{{ item.specialist.name }}</span>
                    </div>
                  </div>
                </div>

                  <div class="slot-card-aside">
                    <slot-participants-row
                      :participants="participantsFor(item)"
                      :loading="participantsLoading"
                      @open="openParticipants(item)"
                    />
                    <div class="slot-card-actions">
                      <waitlist-badge
                        v-if="item.waitlist"
                        :count="item.specialist.slot.waitlist_count"
                      />
                      <div class="d-flex">
                    <v-tooltip
                      class="rounded-tooltip"
                      location="top"
                      v-if="
                        checkDateIfNeeded(
                          item.date,
                          item.specialist.slot.start,
                          item.specialist.slot.end,
                        )
                      "
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-btn variant="text" icon density="compact">
                            <v-icon size="32">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="info">
                                  <mask
                                    id="mask0_4328_23687"
                                    style="mask-type: alpha"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="32"
                                    height="32"
                                  >
                                    <rect
                                      id="Bounding box"
                                      width="32"
                                      height="32"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_4328_23687)">
                                    <path
                                      id="info_2"
                                      d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                      fill="#4E4E4E"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <div class="tooltip-area">
                        <span class="text-normal text-white tooltip-text">
                          {{
                            registeractivity.enroll_type === "other_enroll" ||
                            registeractivity.enroll_type === "enroll_new_user"
                              ? $i18n.locale === "nl"
                                ? `Medewerker is al aangemeld voor  ${functions.getEnroll(
                                    item.date,
                                    item.specialist.slot.start,
                                    item.specialist.slot.end,

                                    $i18n.locale,
                                    registeractivity.enroll_type,
                                  )} op dit tijdstip.`
                                : `Employee is already registered for  ${functions.getEnroll(
                                    item.date,
                                    item.specialist.slot.start,
                                    item.specialist.slot.end,

                                    $i18n.locale,
                                    registeractivity.enroll_type,
                                  )} at this time.`
                              : $i18n.locale === "nl"
                              ? `Je bent al aangemeld voor  ${functions.getEnroll(
                                  item.date,
                                  item.specialist.slot.start,
                                  item.specialist.slot.end,

                                  $i18n.locale,
                                  registeractivity.enroll_type,
                                )} op dit tijdstip`
                              : `You are already signed up for ${functions.getEnroll(
                                  item.date,
                                  item.specialist.slot.start,
                                  item.specialist.slot.end,

                                  $i18n.locale,
                                  registeractivity.enroll_type,
                                )} at this time`
                          }}
                        </span>
                      </div>
                    </v-tooltip>
                    <v-tooltip
                      location="top"
                      v-else-if="item.disabled"
                      class="rounded-tooltip"
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-btn variant="text" icon density="compact">
                            <v-icon size="32">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="info">
                                  <mask
                                    id="mask0_4328_23687"
                                    style="mask-type: alpha"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="32"
                                    height="32"
                                  >
                                    <rect
                                      id="Bounding box"
                                      width="32"
                                      height="32"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_4328_23687)">
                                    <path
                                      id="info_2"
                                      d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                      fill="#4E4E4E"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <div class="tooltip-area">
                        <span class="text-normal text-white tooltip-text">
                          {{
                            registeractivity.enroll_type === "other_enroll" ||
                            registeractivity.enroll_type === "enroll_new_user"
                              ? $i18n.locale === "nl"
                                ? "De medewerker heeft al het maximale aantal activiteiten voor deze periode bereikt."
                                : "The employee has already reached the maximum number of activities for this period."
                              : $i18n.locale === "nl"
                              ? "Je hebt al het maximale aantal activiteiten voor deze periode."
                              : "You have already reached the maximum number of activities for this period."
                          }}
                        </span>
                      </div>
                    </v-tooltip>
                    <v-tooltip
                      location="top"
                      v-else-if="item.full"
                      class="rounded-tooltip"
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-btn variant="text" icon density="compact">
                            <v-icon size="32">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="info">
                                  <mask
                                    id="mask0_4328_23687"
                                    style="mask-type: alpha"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="32"
                                    height="32"
                                  >
                                    <rect
                                      id="Bounding box"
                                      width="32"
                                      height="32"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_4328_23687)">
                                    <path
                                      id="info_2"
                                      d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                      fill="#4E4E4E"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <div class="tooltip-area">
                        <span class="text-normal text-white tooltip-text">
                          {{
                            $i18n.locale === "nl"
                              ? "De activiteit is vol."
                              : "The activity is full."
                          }}
                        </span>
                      </div>
                    </v-tooltip>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="d-flex flex-column ga-2"></div>
            </div>
          </div>
          <div v-else>
            <v-skeleton-loader height="150" type="article" elevation="0">
            </v-skeleton-loader>
          </div>
          </div>
        </div>
      </div>

      <v-slide-group
        v-model="slideGroupModel"
        v-else-if="groupDatesFiltered.length > 1 && is_mobile"
        show-arrows
        class="slide-group"
        :class="changing ? 'changing' : ''"
        direction="horizontal"
        ref="slideGroup"
      >
        <v-slide-group-item
          v-for="(item, index) in groupDatesFiltered"
          :key="index"
        >
          <div class="slot-card-shell">
            <span
              v-if="ready && !item.waitlist"
              class="slot-spots-ribbon"
            >
              {{ spotLabel(item.specialist.slot) }}
            </span>
          <div
            v-if="ready"
            @click="
              !item.disabled &&
              !checkDateIfNeeded(
                item.date,
                item.specialist.slot.start,
                item.specialist.slot.end,
              )
                ? selectItem(item)
                : ''
            "
            class="group-date-card"
            :class="[getClassForDate(item), { 'has-ribbon': !item.waitlist }]"
          >
            <div class="group-mobile-row">
              <div class="group-head">
                <span class="group-register-list-day my-auto">
                  {{ formatWeekday(item.date) }}
                </span>
                <span class="group-register-list-date my-auto">
                  {{ formatDay(item.date) }}
                </span>
                <span class="group-register-list-month my-auto">
                  {{ formatMonth(item.date) }}
                </span>
              </div>
              <div class="group-body">
                <span class="group-register-list-starttime mb-4 d-flex">
                  {{ item.specialist.slot.start }} -
                  {{ item.specialist.slot.end }}
                </span>

                <span
                  v-if="item.specialist.slot.location_type == 'location'"
                  class="group-register-list-address d-block mb-4"
                >
                  {{
                    activity.locations[locationIndex].data.street +
                    ", " +
                    activity.locations[locationIndex].data.postal_code +
                    " " +
                    activity.locations[locationIndex].data.city
                  }}
                </span>
                <span v-else class="group-register-list-address d-block mb-4">
                  Online | <span :style="{ opacity: item.specialist.placeholder ? 0.6 : 1 }">{{ item.specialist.name }}</span>
                </span>
                <span
                  class="group-register-list-address"
                  v-if="item.specialist.slot.location_type == 'location'"
                >
                  <span
                    :style="{
                      opacity: item.specialist.slot.address.room ? 1 : 0.6,
                    }"
                  >
                    {{
                      item.specialist.slot.address.room
                        ? item.specialist.slot.address.room + " | "
                        : $i18n.locale == "nl"
                        ? "Nog niet bekend |"
                        : "Unknown | "
                    }}
                  </span>
                  <span :style="{ opacity: item.specialist.placeholder ? 0.6 : 1 }">{{ item.specialist.name }}</span>
                </span>
                <!-- <span class="group-register-list-address specialist">
                  {{ item.specialist.name }}
                </span> -->
              <div class="slot-card-aside">
                <slot-participants-row
                  :participants="participantsFor(item)"
                  :loading="participantsLoading"
                  @open="openParticipants(item)"
                />
                <div class="slot-card-actions">
                  <div class="d-flex">
                    <v-tooltip
                      class="rounded-tooltip"
                      location="top"
                      v-if="
                        checkDateIfNeeded(
                          item.date,
                          item.specialist.slot.start,
                          item.specialist.slot.end,
                        )
                      "
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-icon size="24">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="info">
                                <mask
                                  id="mask0_4328_23687"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32"
                                >
                                  <rect
                                    id="Bounding box"
                                    width="32"
                                    height="32"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_4328_23687)">
                                  <path
                                    id="info_2"
                                    d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                    fill="#4E4E4E"
                                  />
                                </g>
                              </g>
                            </svg>
                          </v-icon>
                        </div>
                      </template>
                      <div class="tooltip-area">
                        <span class="text-normal text-white tooltip-text">
                          {{
                            $i18n.locale == "nl"
                              ? `Je bent al aangemeld voor ${functions.getEnroll(
                                  item.date,
                                  item.specialist.slot.start,
                                  item.specialist.slot.end,
  
                                  $i18n.locale,
                                  registeractivity.enroll_type,
                                )} op dit tijdstip`
                              : `You are already signed up for ${functions.getEnroll(
                                  item.date,
                                  item.specialist.slot.start,
                                  item.specialist.slot.end,
  
                                  $i18n.locale,
                                  registeractivity.enroll_type,
                                )} at this time`
                          }}
                        </span>
                      </div>
                    </v-tooltip>
                    <v-tooltip
                      v-else-if="item.disabled"
                      class="rounded-tooltip"
                      location="top"
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-icon size="24">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="info">
                                <mask
                                  id="mask0_4328_23687"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32"
                                >
                                  <rect
                                    id="Bounding box"
                                    width="32"
                                    height="32"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_4328_23687)">
                                  <path
                                    id="info_2"
                                    d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                    fill="#4E4E4E"
                                  />
                                </g>
                              </g>
                            </svg>
                          </v-icon>
                        </div>
                      </template>
                      <div class="tooltip-area">
                        <span class="text-normal text-white tooltip-text">
                          {{
                            $i18n.locale == "nl"
                              ? "Je hebt al het maximale aantal activiteiten voor deze periode."
                              : "You have already reached the maximum number of activities for this period."
                          }}
                        </span>
                      </div>
                    </v-tooltip>
                  </div>
                  <waitlist-badge
                    v-if="item.waitlist"
                    :count="item.specialist.slot.waitlist_count"
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <v-skeleton-loader
            v-else
            width="296"
            type="image, article"
            elevation="1"
          >
          </v-skeleton-loader>
          </div>
        </v-slide-group-item>

        <template v-slot:next v-if="ready">
          <v-btn variant="text" icon>
            <v-icon size="32">mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <template v-slot:prev v-if="ready">
          <v-btn variant="text" icon>
            <v-icon size="32">mdi-chevron-left</v-icon>
          </v-btn>
        </template>
      </v-slide-group>
      <div
        v-else-if="groupDatesFiltered.length == 1"
        class="slot-card-shell"
      >
        <span
          v-if="!groupDatesFiltered[0].waitlist"
          class="slot-spots-ribbon"
        >
          {{ spotLabel(groupDatesFiltered[0].specialist.slot) }}
        </span>
        <div
        @click="
          !groupDatesFiltered[0].disabled &&
          !checkDateIfNeeded(
            groupDatesFiltered[0].date,
            groupDatesFiltered[0].specialist.slot.start,
            groupDatesFiltered[0].specialist.slot.end,
          )
            ? selectItem(groupDatesFiltered[0])
            : ''
        "
        class="group-date-card single-card"
        :class="[
          getClassForDate(groupDatesFiltered[0]),
          { 'has-ribbon': !groupDatesFiltered[0].waitlist },
        ]"
      >
        <div class="group-mobile-row">
          <div class="group-head">
            <span class="group-register-list-day my-auto">
              {{ formatWeekday(groupDatesFiltered[0].date) }}
            </span>
            <span class="group-register-list-date my-auto">
              {{ formatDay(groupDatesFiltered[0].date) }}
            </span>
            <span class="group-register-list-month my-auto">
              {{ formatMonth(groupDatesFiltered[0].date) }}
            </span>
          </div>
          <div class="group-body">
            <span class="group-register-list-starttime mb-4 d-flex">
              {{ groupDatesFiltered[0].specialist.slot.start }} -
              {{ groupDatesFiltered[0].specialist.slot.end }}
            </span>

            <span
              v-if="
                groupDatesFiltered[0].specialist.slot.location_type ==
                'location'
              "
              class="group-register-list-address d-block mb-4"
            >
              {{
                activity.locations[locationIndex].data.street +
                ", " +
                activity.locations[locationIndex].data.postal_code +
                " " +
                activity.locations[locationIndex].data.city
              }}
            </span>
            <span v-else class="group-register-list-address d-block mb-4">
              Online | <span :style="{ opacity: groupDatesFiltered[0].specialist.placeholder ? 0.6 : 1 }">{{ groupDatesFiltered[0].specialist.name }}</span>
            </span>
            <span
              class="group-register-list-address"
              v-if="
                groupDatesFiltered[0].specialist.slot.location_type ==
                'location'
              "
            >
              <span
                :style="{
                  opacity: groupDatesFiltered[0].specialist.slot.address.room
                    ? 1
                    : 0.6,
                }"
              >
                {{
                  groupDatesFiltered[0].specialist.slot.address.room
                    ? groupDatesFiltered[0].specialist.slot.address.room + " | "
                    : $i18n.locale == "nl"
                    ? "Nog niet bekend |"
                    : "Unknown | "
                }}
              </span>

              <span :style="{ opacity: groupDatesFiltered[0].specialist.placeholder ? 0.6 : 1 }">{{ groupDatesFiltered[0].specialist.name }}</span>
            </span>
            <!-- <span class="group-register-list-address specialist">
                  {{ item.specialist.name }}
                </span> -->
            <div class="slot-card-aside">
              <slot-participants-row
                :participants="participantsFor(groupDatesFiltered[0])"
                :loading="participantsLoading"
                @open="openParticipants(groupDatesFiltered[0])"
              />
              <div class="slot-card-actions">
                <div class="d-flex">
                <v-tooltip
                  location="top"
                  class="rounded-tooltip"
                  v-if="
                    checkDateIfNeeded(
                      groupDatesFiltered[0].date,
                      groupDatesFiltered[0].specialist.slot.start,
                      groupDatesFiltered[0].specialist.slot.end,
                    )
                  "
                >
                  <template v-slot:activator="{ props }">
                    <div v-bind="props">
                      <v-icon size="24">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="info">
                            <mask
                              id="mask0_4328_23687"
                              style="mask-type: alpha"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="32"
                              height="32"
                            >
                              <rect
                                id="Bounding box"
                                width="32"
                                height="32"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_4328_23687)">
                              <path
                                id="info_2"
                                d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                fill="#4E4E4E"
                              />
                            </g>
                          </g>
                        </svg>
                      </v-icon>
                    </div>
                  </template>
                  <div class="tooltip-area">
                    <span class="text-normal text-white tooltip-text">
                      {{
                        $i18n.locale == "nl"
                          ? `Je bent al aangemeld voor ${functions.getEnroll(
                              groupDatesFiltered[0].date,
                              groupDatesFiltered[0].specialist.slot.start,
                              groupDatesFiltered[0].specialist.slot.end,
  
                              $i18n.locale,
                              registeractivity.enroll_type,
                            )} op dit tijdstip`
                          : `You are already signed up for ${functions.getEnroll(
                              groupDatesFiltered[0].date,
                              groupDatesFiltered[0].specialist.slot.start,
                              groupDatesFiltered[0].specialist.slot.end,
  
                              $i18n.locale,
                              registeractivity.enroll_type,
                            )} at this time`
                      }}
                    </span>
                  </div>
                </v-tooltip>
                <v-tooltip
                  location="top"
                  v-else-if="groupDatesFiltered[0].disabled"
                  class="rounded-tooltip"
                >
                  <template v-slot:activator="{ props }">
                    <div v-bind="props">
                      <v-icon size="24">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="info">
                            <mask
                              id="mask0_4328_23687"
                              style="mask-type: alpha"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="32"
                              height="32"
                            >
                              <rect
                                id="Bounding box"
                                width="32"
                                height="32"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_4328_23687)">
                              <path
                                id="info_2"
                                d="M14.667 22.6667H17.3337V14.6667H14.667V22.6667ZM16.0003 12.0001C16.3781 12.0001 16.6948 11.8723 16.9503 11.6167C17.2059 11.3612 17.3337 11.0445 17.3337 10.6667C17.3337 10.289 17.2059 9.9723 16.9503 9.71675C16.6948 9.46119 16.3781 9.33341 16.0003 9.33341C15.6225 9.33341 15.3059 9.46119 15.0503 9.71675C14.7948 9.9723 14.667 10.289 14.667 10.6667C14.667 11.0445 14.7948 11.3612 15.0503 11.6167C15.3059 11.8723 15.6225 12.0001 16.0003 12.0001ZM16.0003 29.3334C14.1559 29.3334 12.4225 28.9834 10.8003 28.2834C9.1781 27.5834 7.76699 26.6334 6.56699 25.4334C5.36699 24.2334 4.41699 22.8223 3.71699 21.2001C3.01699 19.5779 2.66699 17.8445 2.66699 16.0001C2.66699 14.1556 3.01699 12.4223 3.71699 10.8001C4.41699 9.17786 5.36699 7.76675 6.56699 6.56675C7.76699 5.36675 9.1781 4.41675 10.8003 3.71675C12.4225 3.01675 14.1559 2.66675 16.0003 2.66675C17.8448 2.66675 19.5781 3.01675 21.2003 3.71675C22.8225 4.41675 24.2337 5.36675 25.4337 6.56675C26.6337 7.76675 27.5837 9.17786 28.2837 10.8001C28.9837 12.4223 29.3337 14.1556 29.3337 16.0001C29.3337 17.8445 28.9837 19.5779 28.2837 21.2001C27.5837 22.8223 26.6337 24.2334 25.4337 25.4334C24.2337 26.6334 22.8225 27.5834 21.2003 28.2834C19.5781 28.9834 17.8448 29.3334 16.0003 29.3334Z"
                                fill="#4E4E4E"
                              />
                            </g>
                          </g>
                        </svg>
                      </v-icon>
                    </div>
                  </template>
                  <div class="tooltip-area">
                    <span class="text-normal text-white tooltip-text">
                      {{
                        $i18n.locale == "nl"
                          ? "Je hebt al het maximale aantal activiteiten voor deze periode."
                          : "You have already reached the maximum number of activities for this period."
                      }}
                    </span>
                  </div>
                </v-tooltip>
                </div>
                <waitlist-badge
                  v-if="groupDatesFiltered[0].waitlist"
                  :count="groupDatesFiltered[0].specialist.slot.waitlist_count"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="step-footer pa-6 pa-md-8 pt-md-10">
      <v-row>
        <v-col cols="12" :class="!is_mobile ? 'd-flex' : ''">
          <v-btn
            v-if="is_mobile"
            :block="is_mobile"
            :disabled="
              changing
                ? !registeractivity.date.slot.id
                : !registeractivity.dates.length > 0
            "
            class="btn text-white quickfix-btn"
            color="var(--company-primary)"
            @click="$emit('next-step')"
          >
            {{ $i18n.locale == "nl" ? "Ga verder" : "Continue" }}
          </v-btn>
          <k-spacing y="4" v-if="is_mobile"></k-spacing>

          <v-btn
            :block="is_mobile"
            v-if="firstStep"
            class="btn quickfix-btn"
            color="var(--company-primary)"
            variant="outlined"
            @click="$emit('close-dialog')"
          >
            {{ $t("components.changeActivityDialogDialog.dialog_close_btn") }}
          </v-btn>
          <v-btn
            :block="is_mobile"
            v-else
            class="btn quickfix-btn"
            color="var(--company-primary)"
            variant="outlined"
            @click="$emit('prev-step')"
          >
            {{ $i18n.locale === "nl" ? "Stap terug" : "Previous" }}
          </v-btn>
          <k-spacing x="4"></k-spacing>
          <v-btn
            v-if="!is_mobile"
            :disabled="
              changing
                ? !registeractivity.date.slot.id
                : !registeractivity.dates.length > 0
            "
            class="btn text-white quickfix-btn"
            color="var(--company-primary)"
            @click="$emit('next-step')"
          >
            {{ $i18n.locale == "nl" ? "Ga verder" : "Continue" }}
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <deelnemers-dialog
      v-model="participantsDialog"
      :dates="participantDates"
      :initial-date-id="participantsDialogDateId"
      @close-dialog="participantsDialog = false"
    />
  </div>
</template>

<script>
import api from "../../services/api";
import config from "../../config";
import { useMainStore } from "@/stores/store";
import functions from "@/util/functions";
import WaitlistBadge from "@/components/waitlist-badge.vue";
import SlotParticipantsRow from "@/components/slot-participants-row.vue";
import DeelnemersDialog from "@/components/dialogs/deelnemersDialog.vue";
import { dateIdForSlot, participantsForSlot, participantsVisible } from "@/util/participants";
import { getAmsterdamDateKey, toAmsterdamCalendarDate } from "@/util/DateUtil";
import { creditAllowance } from "@/util/activityCredits";

export default {
  components: { WaitlistBadge, SlotParticipantsRow, DeelnemersDialog },
  props: [
    "activity",
    "registeractivity",
    "page",
    "stepLabel",
    "locationIndex",
    "is_mobile",
    "enroll",
    "changing",
    "firstStep",
    "public_page",

    "locationActive",
  ],
  emits: ["prev-step", "next-step", "update-registeractivity"],
  mounted() {
    this.checkCredits();
    this.loadParticipants();
  },
  data() {
    return {
      slideGroupModel: 0,
      activeDate: null,
      ready: false,
      functions: functions,
      tempSelectedDates: [],
      credits: [],
      first_select: true,
      period: null,
      translateX: 0, // Track the translation
      slideWidth: 250, // Adjust based on your card width
      mainstore: useMainStore(),
      // De volledige deelnemersplanning van deze activiteit: één read voedt
      // alle kaarten (ADR-0060).
      participantDates: [],
      participantsLoading: false,
      participantsDialog: false,
      participantsDialogDateId: null,
      localRegisterActivity: JSON.parse(JSON.stringify(this.registeractivity)), // Make a local copy
    };
  },
  computed: {
    groupDatesFiltered() {
      const dateMap = new Map();
      const location = this.locationIndex;

      // Determine whether to use multiple dates (group) or a single date (changing)
      const selectedDates = this.changing
        ? this.registeractivity.date && this.registeractivity.date.date
          ? [this.registeractivity.date] // Wrap single object in array
          : []
        : this.registeractivity.dates
        ? this.registeractivity.dates.filter((date) => date.date) // Filter out null/undefined dates
        : [];

      // Group existing selected dates by period for credit comparison
      const datesGroupedByPeriod = {};
      selectedDates.forEach((date) => {
        if (!date.date) return; // Skip if date.date is null/undefined

        const periodStartDate = this.getPeriodStartDate(
          this.dayKey(date.date),
          this.period,
        );

        if (!datesGroupedByPeriod[periodStartDate]) {
          datesGroupedByPeriod[periodStartDate] = [];
        }
        datesGroupedByPeriod[periodStartDate].push(date.date);
      });

      // Iterate through each location and its specialists
      this.activity.locations[location].specialists.forEach(
        ({ name, id, dates, placeholder }) => {
          dates.forEach(({ date, slots }) => {
            if (!date) return; // Skip if date is null/undefined

            const formattedDate = this.dayKey(date);

            const periodStartDate = this.getPeriodStartDate(
              formattedDate,
              this.period,
            );
            const datesInPeriod = datesGroupedByPeriod[periodStartDate] || [];
            const isDisabled =
              datesInPeriod.length >= (this.credits[periodStartDate] || 0);

            slots.forEach((slot) => {
              // Vol + wachtlijst aan blijft selecteerbaar; alleen echt vol blokkeert.
              const waitlist = functions.slotWaitlist(slot);
              const full = slot.spots - slot.enrolls.length < 1 && !waitlist;

              const alreadySelected = selectedDates.some((activityDate) => {
                return (
                  activityDate.date === date && slot.id === activityDate.slot.id
                );
              });

              // Check if there are entries for this date, if not initialize an array
              if (!dateMap.has(formattedDate)) {
                dateMap.set(formattedDate, []);
              }

              // Append each slot to the date's array
              dateMap.get(formattedDate).push({
                date: date,
                specialist: {
                  id,
                  location,
                  name,
                  // "Nog niet bekend" staat lichtgrijs, net als een onbekende
                  // ruimte ernaast (ClickUp 1240ccekkc7).
                  placeholder: placeholder === true,
                  slot,
                },
                full: full,
                waitlist: waitlist,
                disabled: isDisabled && !alreadySelected ? isDisabled : false, // Disable if needed
              });
            });
          });
        },
      );

      // Flatten and sort the array by date
      return Array.from(dateMap.values())
        .flat()
        .sort(
          (a, b) =>
            this.dayKey(a.date).localeCompare(this.dayKey(b.date)) ||
            String(a.date).localeCompare(String(b.date)),
        );
    },
    // De keuze van de activiteit, anders die van de bedrijfspagina (ADR-0059,
    // ClickUp 1240ccecgzt). De server weigert de read zelf; dit voorkomt alleen
    // een kansloze request.
    participantsEnabled() {
      return participantsVisible(this.page?.settings, this.activity?.content);
    },

    uiLocale() {
      return this.$i18n?.locale === "nl" ? "nl-NL" : "en-GB"; // of 'en-US' als je dat liever hebt
    },
  },
  methods: {
    // Uit @/util/DateUtil, zodat de template hem kan aanroepen.
    toAmsterdamCalendarDate,
    // De kalenderdag van een datum in deze stap, als YYYY-MM-DD — dezelfde als
    // in StepThree. Elk scherm dat deze stap opent zet de specialistdatums al
    // met toAmsterdamCalendarDate om: een lokale middernacht, dus de lokale dag
    // ís de Amsterdamse. Die Date nog eens in Europe/Amsterdam lezen gaf oost
    // van Amsterdam de dag ervoor (een maandag viel in de week ervoor).
    dayKey(date) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${month}-${day}`;
    },
    /**
     * De deelnemers van dít tijdslot. Een kaart biedt één tijdslot aan, dus
     * toont hij die mensen — niet de activiteitbrede rij van de
     * activiteitenpagina (ADR-0060).
     */
    participantsFor(item) {
      return participantsForSlot(
        this.participantDates,
        item?.specialist?.slot?.id,
      );
    },

    /**
     * De popup toont de héle activiteit, opengeklapt op de datum van de kaart
     * waarop geklikt is: in deze stap vergelijk je juist datums (ADR-0060).
     */
    openParticipants(item) {
      this.participantsDialogDateId = dateIdForSlot(
        this.participantDates,
        item?.specialist?.slot?.id,
      );
      this.participantsDialog = true;
    },

    loadParticipants() {
      // De publieke inschrijflink heeft geen page membership en leert dus
      // nooit wie er meedoet (ADR-0059). Het endpoint zou hem sowieso
      // weigeren; een request die je op voorhand kent stuur je niet.
      if (this.public_page || !this.participantsEnabled || !this.activity?.id) {
        return;
      }

      this.participantsLoading = true;
      api
        .get(`/v1/activities/${this.activity.id}/participants`)
        .then((res) => {
          this.participantDates = res.data.success || [];
        })
        .catch(() => {
          // Ook een 403 landt hier: de server heeft het laatste woord over de
          // instelling, en dan horen de rijen gewoon weg te blijven.
          this.participantDates = [];
        })
        .finally(() => {
          this.participantsLoading = false;
        });
    },

    spotLabel(slot) {
      const en = this.$i18n?.locale === "en";
      const spots = slot.spots - slot.enrolls.length;
      if (spots <= 0) return en ? "No spots left" : "Geen plekken beschikbaar";
      if (spots === 1)
        return en ? "Only 1 spot left" : "Nog maar 1 plek beschikbaar";
      return en
        ? `Only ${spots} spots left`
        : `Nog maar ${spots} plekken beschikbaar`;
    },
    formatText() {
      if (this.registeractivity.enroll_type == "self_enroll") {
        return this.$i18n.locale == "nl"
          ? "Leuk dat jij je aanmeldt voor:"
          : "Nice of you to sign up for:";
      } else {
        return this.$i18n.locale == "nl"
          ? "Leuk dat je een medewerker wilt aanmelden voor:"
          : "Nice of you to sign somebody up for:";
      }
    },
    prevSlide() {
      const container = this.$refs.slideGroup?.$el?.querySelector(
        ".v-slide-group__content",
      );
      if (container) {
        this.translateX = Math.min(this.translateX + this.slideWidth, 0);
        container.style.transform = `translateX(${this.translateX}px)`;
      }
    },
    nextSlide() {
      const container = this.$refs.slideGroup?.$el?.querySelector(
        ".v-slide-group__content",
      );
      if (container) {
        const maxTranslateX = -(container.scrollWidth - container.clientWidth); // Prevent overscrolling
        this.translateX = Math.max(
          this.translateX - this.slideWidth,
          maxTranslateX,
        );
        container.style.transform = `translateX(-${this.translateX}px)`;
      }
    },

    checkDateIfNeeded(date, start, end) {
      if (this.getCookie("fmw_access_token")) {
        return this.functions.checkDate(
          date,
          start,
          end,
          this.registeractivity.enroll_type,
        );
      } else {
        return false;
      }
    },
    getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)"),
      );
      return match ? match[2] : false;
    },
    selectItem(item) {
      if (!this.changing) {
        const index = this.registeractivity.dates.findIndex(
          (dateItem) => dateItem.slot.id === item.specialist.slot.id,
        );

        let updatedDates = [...this.registeractivity.dates];
        if (index !== -1) {
          updatedDates.splice(index, 1);
        } else {
          updatedDates.push({
            date: item.date,
            slot: item.specialist.slot,
            specialist: item.specialist.name,
          });
        }
        this.$emit("update-data", { dates: updatedDates });
      } else {
        let updatedDate = this.registeractivity.date;

        if (this.registeractivity.date.slot.id == item.specialist.slot.id) {
          updatedDate = {
            date: null,
            slot: {},
            specialist: item.specialist.name,
          };
        } else {
          updatedDate = {
            date: item.date,
            slot: item.specialist.slot,
            specialist: item.specialist.name,
          };
        }
        this.$emit("update-data", { date: updatedDate, dates: [updatedDate] });
      }
    },
    formatMonth(date) {
      const d = new Date(date);
      return d.toLocaleDateString(this.uiLocale, {
        month: "short",
      });
    },
    formatDay(date) {
      const d = new Date(date);
      return d.toLocaleDateString(this.uiLocale, {
        day: "numeric",
      });
    },
    formatWeekday(date) {
      const d = new Date(date);
      const w = d.toLocaleDateString(this.uiLocale, {
        weekday: "long",
      });
      return w.charAt(0).toUpperCase() + w.slice(1); // in NL zijn weekdagen standaard lowercase
    },

    getClassForDate(item) {
      let class_thing = "group-date-card";

      const selectedDates = this.changing
        ? this.registeractivity.date && this.registeractivity.date.slot
          ? [this.registeractivity.date] // Wrap single object in array
          : []
        : this.registeractivity.dates
        ? this.registeractivity.dates.filter((dateItem) => dateItem.slot) // Ensure slot exists
        : [];

      const isSelected = selectedDates.some(
        (dateItem) => dateItem.slot.id === item.specialist.slot.id,
      );

      if (isSelected) {
        class_thing += " selected-date";
      }

      if (
        (item.disabled && !isSelected) ||
        item.full ||
        this.checkDateIfNeeded(
          item.date,
          item.specialist.slot.start,
          item.specialist.slot.end,
        )
      ) {
        class_thing += " disabled-card";
      }
      // if (this.groupDatesFiltered.length < 2) {
      //   class_thing += " w-100";
      // }
      return class_thing;
    },

    getPeriodStartDate(date, period) {
      return this.functions.getPeriodStartYmd(date, period);
    },
    filterDates(dates) {
      // Sort the array based on the 'date' property
      dates.sort((a, b) => {
        // Convert the 'date' strings to Date objects for comparison
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA - dateB;
      });

      // Return the sorted array
      return dates;
    },
    checkCredits() {
      const token = this.getCookie("fmw_access_token");

      if (token) {
        let dateObject = {
          dates: this.groupDatesFiltered.map((d) => this.dayKey(d.date)),
          type: this.registeractivity.enroll_type,
          user: this.registeractivity.user?.id ?? null,
          activity: this.activity?.id ?? null,
        };
        api
          .post(
            `${config.url.api}/v1/activities/${this.page.id}/checkcredits`,
            dateObject,
          )
          .then((res) => {
            this.credits = res.data.dates;
            this.period = res.data.period;
            if (this.changing && this.enroll.date) {
              // enroll.date is een epoch, geen kalenderdatum: die lees je wél
              // in Amsterdam.
              const formattedEnrollDate = this.getPeriodStartDate(
                getAmsterdamDateKey(this.enroll.date),
                this.period,
              );

              if (this.credits[formattedEnrollDate]) {
                this.credits[formattedEnrollDate] += 2;
              } else {
                this.credits[formattedEnrollDate] = 2;
              }
            }

            this.ready = true;
          });
      } else {
        // No token -> Use max credits from store settings
        this.credits = this.getMaxCreditsForPeriod();
        this.period = creditAllowance(this.mainstore.companypage.settings, this.activity).period;
        this.ready = true;
      }
    },
    // Uitgelogd (openbare pagina) is er geen gebruiker wiens boekingen tellen:
    // elke periode krijgt het volle aantal van de pagina, gesleuteld zoals
    // groupDatesFiltered ze opzoekt (zie StepThree).
    getMaxCreditsForPeriod() {
      // Eigen credits van de activiteit winnen van die van de pagina (86c6gv8yw).
      const { credits, period } = creditAllowance(
        this.mainstore.companypage.settings,
        this.activity,
      );
      const maxCredits = credits === null ? 1000000 : credits;
      const periodCredits = {};

      for (const { date } of this.groupDatesFiltered) {
        periodCredits[this.getPeriodStartDate(this.dayKey(date), period)] =
          maxCredits;
      }

      return periodCredits;
    },
  },
};
</script>
